import LogoImg from "@/../../public/images/pelorus-logo.svg";
import Welcomeback from "@/../../public/images/welcomeback.svg";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { FaRegEyeSlash } from "react-icons/fa6";
import { FaRegEye } from "react-icons/fa6";
import AuthFooterScreen from "../../../component/layout/authfooter";
import React, { useState } from "react";
import { AppRoute } from "../../../router/routerConstants";
import { Modal } from "react-bootstrap";

import { useDispatch } from "react-redux";
import { setUser } from "../../../store/auth.store";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import * as yup from "yup";
import { useFormik } from "formik";
import { logInUserApi } from "../../../service/apis/auth.api";
import { GoBriefcase } from "react-icons/go";
import { FiUser } from "react-icons/fi";
import { RiCustomerService2Line } from "react-icons/ri";
import { ValidationCons } from "../../../validation/validationConstant";
import { setItemWithExpiry, showError } from "../../../utils/Common";
import { useLocation } from "react-router-dom";
import { ResumeDetails, setResumeDetails } from "../../../store/resume.store";

const AgntLoginScreen = () => {
  const dispatch = useDispatch();
  const [NavigateTo] = useCustomNavigate();
  const [loading, setLoading] = useState(false);

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const [showRegisterAs, setShowRegisterAs] = useState(false);
  const handleCloseRA = () => setShowRegisterAs(false);
  const handleShowRA = () => setShowRegisterAs(true);
  const location = useLocation();
  const { jobId } = location?.state || {}; // Access the passed state

  // const { user } = useSelector((state: RootState) => state.authSlice);

  // const handleRememberMe = (e: React.ChangeEvent<HTMLInputElement>) => {
  //     const isChecked = e.target.checked;
  //     setRememberMe(isChecked);
  // };

  const loginFormik = useFormik({
    initialValues: {
      email: "",
      password: "",
      rememberMe: false,
      isPasswordVisible: false,
    },
    validationSchema: yup.object({
      email: yup
        .string()
        .email(ValidationCons.IS_EMAIL)
        .required(ValidationCons.EMAIL_REQUIRED),
      password: yup
        .string()
        .trim()
        .min(8, ValidationCons.PASSWORD_CASE)
        .max(15, "Password must not exceed 15 characters")
        .required(ValidationCons.PASSWORD_REQUIRED)
        .matches(
          /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,15}$/,
          ValidationCons.PASSWORD_MATCH
        ),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        const bodyData = {
          email: values.email,
          password: values.password,
        };
        const response = await logInUserApi(bodyData);
        if (response?.message === "Login successful" && response?.user?.role!=="admin") {
          const updatedDetails = {
            resumeDetails:
              response?.user?.resumeDetails &&
              response?.user?.resumeDetails?.map((resumeDetail: any) => ({
                name: resumeDetail?.resume?.resumeData?.name,
                bio: resumeDetail?.resume?.resumeData?.bio,
                email: resumeDetail?.resume?.resumeData?.email,
                explevel: resumeDetail?.resume?.resumeData?.explevel,
                contact: resumeDetail?.resume?.resumeData?.contact,
                experiences: resumeDetail?.resume?.resumeData?.experiences,
                skills: resumeDetail?.resume?.resumeData?.skills,
                achievements: resumeDetail?.resume?.resumeData?.achievements,
                educations: resumeDetail?.resume?.resumeData?.educations,
                resumeLink: resumeDetail?.resume?.resumeLink,
              })),
          };
          setLoading(false);

          dispatch(setUser(response?.user));

          if (values.rememberMe) {
            // localStorage.setItem("access_token", response.tokens.access);
            localStorage.setItem("refresh_token", response.tokens.refresh);
            setItemWithExpiry("access_token", response.tokens.access, 1);
            // setItemWithExpiry("refresh_token",response.tokens.refresh,1);
          } else {
            sessionStorage.setItem("access_token", response.tokens.access);
            sessionStorage.setItem("refresh_token", response.tokens.refresh);
          }
          const role = response?.user?.role;
          const params = {
            jobId: jobId,
            firstName: response?.user?.firstName,
            lastName: response?.user?.lastName,
            email: response?.user?.email,
            role: response?.user?.role,
            userId: response?.user?._id,
            tokenData: response.tokens,
          };

          if (role === "jobseeker") {
            if (response?.user?.isEmailVerified === false) {
              NavigateTo(AppRoute.AGENT_REGISTER_STEP3, false, params);
            } else {
              updatedDetails.resumeDetails.forEach(
                (resumeDetail: ResumeDetails) => {
                  dispatch(setResumeDetails(resumeDetail));
                }
              );
              if (jobId) {
                NavigateTo(AppRoute.JOBSEEKER_JOBS_DETAILS, false, params);
              } else {
                NavigateTo(AppRoute.JOBSEEKER_DASHBOARD, false);
              }
            }

            // console.log(usER,r?.user);
          } else if (role === "localagents") {
            // updatedDetails.resumeDetails.forEach(
            //   (resumeDetail: ResumeDetails) => {
            //     dispatch(addResumeToList(resumeDetail));
            //   }
            // );
            // console.log("resumelist", resumeList);
            if (response?.user?.isEmailVerified === false) {
              NavigateTo(AppRoute.AGENT_REGISTER_STEP3, false, params);
            } else {
              if (jobId) {
                NavigateTo(AppRoute.AGENT_JOBS_DETAILS, false, params);
              } else {
                NavigateTo(AppRoute.AGENT_DASHBOARD, false);
              }
            }
          } else if (role === "employer") {
            if (response?.user?.isEmailVerified === false) {
              NavigateTo(AppRoute.EMPLOYEE_REGISTER_STEP3, false, params);
            } else {
              NavigateTo(AppRoute.EMPLOYER_DASHBOARD, false);
            }
          }
        }
        else if (response?.message === "Login successful" && response?.user?.role==="admin"){
        //   setLoading(false);
          showError("Admin Login not allowed here");
        }
      } catch (error: any) {
        // setLoading(false);
        showError(error?.message);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <header className="header common-padd-lt-rt common-padd-small pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="logo text-left">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a onClick={() => NavigateTo(AppRoute.SPLASH)}>
                  <img src={LogoImg} alt="logo" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="main-authModule">
        <section className="welcomebodylogin common-padd">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 leftlargeImg">
                <img src={Welcomeback} alt="logo" />
              </div>
              <div className="col-lg-6">
                <div className="welcome-holder">
                  <h1>Welcome Back!</h1>
                  <p>
                    To keep connected with us please login with your personal
                    info.
                  </p>
                  <div className="login-form-area mt-5">
                    <Form onSubmit={loginFormik.handleSubmit}>
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter your email address"
                          name="email"
                          onChange={loginFormik.handleChange}
                          onBlur={loginFormik.handleBlur}
                          value={loginFormik.values.email}
                          isInvalid={
                            !!loginFormik.errors.email &&
                            Boolean(loginFormik.touched.email)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {typeof loginFormik.errors.email === "string" &&
                            loginFormik.errors.email}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        className="mb-3 position-relative"
                        controlId="formBasicPassword"
                      >
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                          type={isPasswordVisible ? "text" : "password"}
                          placeholder="Enter your password"
                          name="password"
                          onChange={loginFormik.handleChange}
                          value={loginFormik.values.password}
                          onBlur={loginFormik.handleBlur}
                          style={{ backgroundImage: "none" }}
                          isInvalid={
                            !!loginFormik.errors.password &&
                            Boolean(loginFormik.touched.password)
                          }

                          //errorMsg={loginFormik.errors.password}
                        />

                        <div
                          className={`eye-icon ${
                            isPasswordVisible ? "red" : ""
                          }`}
                        >
                          {isPasswordVisible ? (
                            <FaRegEye
                              onClick={() => setIsPasswordVisible(false)}
                            />
                          ) : (
                            <FaRegEyeSlash
                              onClick={() => setIsPasswordVisible(true)}
                            />
                          )}
                        </div>
                        <Form.Control.Feedback type="invalid">
                          {typeof loginFormik.errors.password === "string" &&
                            loginFormik.errors.password}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <div className="forgot-password-holder d-flex">
                        <Form.Group className="mb-3" controlId="rememberMe">
                          <Form.Check
                            type="checkbox"
                            label="Remember Me"
                            onChange={loginFormik.handleChange}
                            checked={loginFormik.values.rememberMe}
                            name="rememberMe"
                          />
                        </Form.Group>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a onClick={() => NavigateTo(AppRoute.FORGOTPASS)}>
                          Forgot Password?
                        </a>
                      </div>
                      <div className="btn-holder mt-3">
                        <Button
                          className="btn w-100 btn-primary"
                          variant="primary"
                          type="submit"
                        >
                          {loading ? "Signing In..." : "Sign In"}
                        </Button>
                      </div>
                    </Form>
                    <div className="register-now mt-3 text-center">
                      <p>
                        Don't have an account?{" "}
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a onClick={handleShowRA}>Register Now</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      {/* Register As model*/}
      <Modal
        show={showRegisterAs}
        onHide={handleCloseRA}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody text-center">
            <h3>Register As:</h3>
            <div className="d-flex gp-10">
              <Button
                className="btn btn-black empbtn"
                type="button"
                onClick={() =>
                  NavigateTo(AppRoute.EMPLOYEE_REGISTER, false, {
                    jobId: jobId,
                  })
                }
              >
                {" "}
                <GoBriefcase /> Employer
              </Button>
              <Button
                className="btn btn-black jobsbtn"
                type="button"
                onClick={() =>
                  NavigateTo(AppRoute.JOBSEEKER_REGISTER, false, {
                    jobId: jobId,
                  })
                }
              >
                {" "}
                <FiUser /> Job Seeker
              </Button>
              <Button
                className="btn btn-black agentbtn"
                type="button"
                onClick={() =>
                  NavigateTo(AppRoute.AGENT_REGISTER, false, { jobId: jobId })
                }
              >
                {" "}
                <RiCustomerService2Line /> Local Agency
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Register As model*/}
    </>
  );
};
export default AgntLoginScreen;
